import moment from "moment";

import { EVENTS_DATE_FORMAT } from "../../common/events.constants";
import {
  IParsedTanksData,
  IParsedTlmEvent,
  ITanksData,
  ITlmEventsTableRow,
} from "../../common/events.models";
import { useGetTimestreamDataToExport } from "../../common/hooks/useGetTimestreamDataToExport";

export const useGetTlmEventsToExport = () => {
  const { fetchTimestreamDataToExport, loading } =
    useGetTimestreamDataToExport();

  const getCsvDataToExport = async (): Promise<ITlmEventsTableRow[]> => {
    const rows = await fetchTimestreamDataToExport(mapData);

    return rows;
  };

  const mapData = (parsedData: IParsedTlmEvent[]): ITlmEventsTableRow[] => {
    const mappedData: ITlmEventsTableRow[] =
      parsedData?.map((item: IParsedTlmEvent, index: number) => {
        let tanksData = "";

        if (item.data) {
          try {
            const tanks: IParsedTanksData[] = JSON.parse(item.data);

            const mappedTanks: ITanksData[] = tanks.map(tank => ({
              TankID: tank.tank_id,
              TankNumber: tank.tank_number,
              TankLevel: tank.tank_level,
              LevelPercent: tank.level_percent,
            }));

            tanksData = JSON.stringify(mappedTanks, null, 2);
          } catch (e) {
            console.error("Error parsing tanks data:", e);
          }
        }

        return {
          rowIndex: index + 1,
          rowId: item?.id ?? "",
          location: item?.location_id ?? "",
          tanksData: tanksData,
          timestamp: moment.utc(item?.time).local().format(EVENTS_DATE_FORMAT),
          mediaOutput: item?.mediaOutput ?? "",
          keyFrame: item?.keyFrame ?? "",
          cameraId: item?.camera_id ?? "",
        };
      }) ?? [];

    return mappedData;
  };

  return { loading, getCsvDataToExport };
};
